import rootReducer from './reducers/rootReducer';
import { Store } from "@green24/npm-preact-utils/store";
import { AppUtils } from "../utils/AppUtils";

export default () => new Store(rootReducer, undefined, AppUtils.isDev);
